import React from 'react';
import {DataItem, TextInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey: string;
}

export const Import = (
  key: string = 'postalCode',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Postal Code',
  key,
});

const resolveDisplayValue = (value: string) => {
  return value;
};

const PostalCodeDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Postal Code</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const PostalCodeInput = ({valueKey}: Props) => {
  return (
    <TextInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'postalCode'}
      name={'Postal Code'}
      required={false}
    />
  );
};

export const validation = () =>
  Yup.string().required('Postal Code is required');

export const Display = PostalCodeDisplay;
export const Input = PostalCodeInput;
export const Value = resolveDisplayValue;

export default PostalCodeInput;
